/* eslint-disable no-console */
import React, {useEffect, useState} from 'react';
import {Cell, Label, Pie, PieChart, ResponsiveContainer} from 'recharts';

import {returnMaxAndMin} from '../../../pages/netZero/utils/commonFunctions';
import {sortBy} from '../../../shared/commonFunctions';
import {formatIndian} from '../../../utils/formatIndian';
import {convertGjToTjWithUnit} from '../../../utils/formatValueWithUnit';

// import {preparePieChartData} from './utils/commonFunctions';

const ProgressChart: React.FC<{
  data: any;
  mainData?: any;
  labelType?: 'value' | 'percent';
  customLabel?: string;
  showLabel?: boolean;
  withTotal?: boolean;
  convertToTJ?: boolean;
  checkSingle?: boolean;
}> = ({
  data,
  mainData,
  labelType = 'value',
  customLabel = '',
  showLabel = true,
  withTotal = false,
  convertToTJ = false,
  checkSingle = true
}) => {
  const isSingle = data.length <= 1;
  const [progressData, setProgressData] = useState<any[]>([]);
  let dataFill: string[] = ['#77C351', '#E0EFFD'];

  useEffect(() => {
    if (
      data?.every((item: any) => {
        return item?.value === 0 || typeof item?.value !== 'number';
      })
    ) {
      data = [{value: 100, fill: '#E0EFFD'}];
      setProgressData([{value: 100, fill: '#E0EFFD'}]);
    } else if (isSingle) {
      if (Array.isArray(data?.[0]?.fill)) {
        dataFill = data?.[0]?.fill ?? ['#77C351', '#E0EFFD'];
      }
      data.unshift({
        value: withTotal
          ? mainData?.value
          : checkSingle
            ? 100
            : 100 - mainData?.value,
        fill: dataFill?.[1] ?? '#E0EFFD'
      });
      data[1].fill = dataFill?.[0] ?? '#E0EFFD';
      setProgressData(data);
    } else {
      setProgressData(sortBy(data, 'value', 'dec'));
    }
  }, [data]);

  const {min} = returnMaxAndMin(data);

  const mainTitle = mainData?.label?.split(' ') ?? [''];
  const lastWord = mainTitle?.[mainTitle?.length - 1];

  const CustomCenterLabel = ({props}: any) => {
    const {cx, cy} = props.viewBox;
    const bol = mainData?.description && labelType !== 'percent';

    return (
      <g style={{outline: 'none'}}>
        {bol && (
          <text
            x={cx}
            y={cy - 15}
            fill="#677489"
            className="recharts-text recharts-label"
            textAnchor="middle"
            dominantBaseline="central"
            style={{
              font: 'normal normal 600 12px/15px Montserrat',
              marginBottom: '1rem',
              outline: 'none'
            }}
          >
            {customLabel !== '' ? customLabel : `Total ${lastWord}`}
          </text>
        )}

        <text
          x={cx}
          y={bol ? cy + 10 : cy}
          fill="#677489"
          className="recharts-text recharts-label"
          textAnchor="middle"
          dominantBaseline="central"
          style={{outline: 'none'}}
        >
          <tspan
            alignmentBaseline="middle"
            fontSize="18"
            style={{
              font: 'normal normal 600 18px/24px Montserrat'
            }}
          >
            {convertToTJ
              ? convertGjToTjWithUnit(
                  mainData?.value,
                  mainData?.unit ? mainData?.unit : min?.unit ?? ''
                )
              : `${formatIndian(mainData?.value)} ${
                  mainData?.unit ? mainData?.unit : min?.unit ?? ''
                }`}
          </tspan>
          {/* <tspan
            baselineShift="sub"
            style={{
              font: 'normal normal 600 14px / 18px Montserrat'
            }}
          >
            {` ${mainData?.unit ? mainData?.unit : min?.unit ?? ''}`}
          </tspan> */}
        </text>
      </g>
    );
  };

  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      style={{flex: 1}}
      className="dontContain"
    >
      <PieChart>
        <Pie
          data={progressData}
          dataKey="value"
          innerRadius="80%"
          outerRadius="100%"
          startAngle={0}
          endAngle={360}
          paddingAngle={-10}
          cornerRadius={20}
          blendStroke
          // minAngle={5}
          style={{outline: 'none'}}
        >
          {showLabel && (
            <Label
              style={{outline: 'none', backgroundColor: 'red', color: 'green'}}
              position="center"
              content={(props) => (
                <CustomCenterLabel props={props} data={mainData} />
              )}
            />
          )}
          {progressData?.map((entry: any) => {
            return (
              <Cell
                style={{outline: 'none'}}
                key={`cell-${entry?.dataId}`}
                fill={entry?.fill ?? '#E0EFFD'}
              />
            );
          })}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ProgressChart;
